import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { InvestmentsNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Investments';
import { FoundationsNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Foundations';
import { HomeNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Home';
import { Logout } from 'Components/ClientApp/CombinedApp/Navigation/TopNav/Logout';
import {
  ReferralPageNavButton,
} from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/ReferralPageNavButton';
import { LogoNavButton } from '../HydratedNavButtons/Logo';
import { MessagesNavButton } from '../HydratedNavButtons/Messages';
import { ProfileNavButton } from '../HydratedNavButtons/Profile';

export const ClientNavFoundationalOnly = () => {
  // BE CAREFUL ADJUSTING THIS FILE!
  // EVEN THE SLIGHTEST ADJUSTMENT CAN CAUSE THE UI TO WRAP AT ITS MOBILE BREAKPOINT (960px at time of writing)
  return (
    <>
      <FDStack alignItems="center">
        <LogoNavButton />
        <HomeNavButton />
        <FoundationsNavButton />
        <InvestmentsNavButton />
        <ReferralPageNavButton />
      </FDStack>
      <FDStack alignItems="center">
        <MessagesNavButton />
        <ProfileNavButton />
        <Logout />
      </FDStack>
    </>
  );
};
